// extracted by mini-css-extract-plugin
module.exports = {"termsAndConditions":"SignInUpModal_termsAndConditions___soIT"};